<div #imageSlider class="slider-container-v2" dpadScrollableHorizontal [type]="'imageSlider'" [scrollLeftPaddingPx]="30">
    <div class="slider-inner">
        <div class="slider-item-v2" *ngFor='let item of displayItems; let i = index' [style.width.%]="width">

            <app-video-thumb
                #thumbs
                *ngIf="item !== undefined && (type == 'thumbs' || type.startsWith('media-list') || type === 'season-banner' || type === 'hot-list' || type === 'user-recommendations' || type === 'creator-row')"
                [media]="item"
                [thumbnailType]="thumbnailType"
                (focused)="thumbFocused(i)"
                [dstart]="(currentFocus || (rowIndex === 0 && rowFocusIndex < 1)) && i === focusedIndex"
                [isSeasonBanner]="type === 'season-banner'"
                [isContinueWatching]="isContinueWatching"
                [recommendationId]="recommendationId"
                [isShowsPage]="isShowsPage">
            </app-video-thumb>

            <app-video-thumb
                #thumbs
                *ngIf="item !== undefined && (type === 'creator-list')"
                [media]="item"
                [creatorTeam]="item"
                [thumbnailType]="thumbnailType"
                (focused)="thumbFocused(i)"
                [dstart]="(currentFocus || (rowIndex === 0 && rowFocusIndex < 1)) && i === focusedIndex"
                [isSeasonBanner]="type === 'season-banner'"
                [isContinueWatching]="isContinueWatching"
                [recommendationId]="recommendationId"
                [isShowsPage]="isShowsPage">
            </app-video-thumb>

            <app-show-thumb
                #thumbs
                *ngIf="item !== undefined && (type == 'show-list')"
                [item]="item"
                (focused)="thumbFocused(i)"
                [dpadStart]="currentFocus && i === focusedIndex">
            </app-show-thumb>

            <div class="w-100" *ngIf="item === undefined">

            </div>
        </div>
    </div>
</div>
